/**
 * INFINITY LIFE 2.0 — Text, Currency and Badge Formatters
 */

export function formatCurrencyBRL(value) {
  const num = typeof value === 'number' ? value : parseFloat(value) || 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(num);
}

export function getPriorityMeta(priority) {
  switch (priority) {
    case 'urgent':
      return { label: 'Urgente', class: 'badge-urgent', color: '#f43f5e', icon: '🔥' };
    case 'high':
      return { label: 'Alta', class: 'badge-high', color: '#f97316', icon: '⚡' };
    case 'medium':
      return { label: 'Média', class: 'badge-medium', color: '#6366f1', icon: '🔹' };
    case 'low':
      return { label: 'Baixa', class: 'badge-low', color: '#10b981', icon: '🌱' };
    default:
      return { label: 'Normal', class: 'badge-default', color: '#64748b', icon: '•' };
  }
}

export function getLocationMeta(location) {
  switch (location) {
    case 'online':
      return { label: 'Online', icon: '🌐' };
    case 'computer':
      return { label: 'Computador', icon: '💻' };
    case 'mobile':
      return { label: 'Celular', icon: '📱' };
    case 'call':
      return { label: 'Ligação', icon: '📞' };
    case 'meeting':
      return { label: 'Reunião', icon: '👥' };
    case 'in_person':
      return { label: 'Presencial', icon: '📍' };
    default:
      return { label: 'Qualquer local', icon: '⚡' };
  }
}

export function getStatusMeta(status) {
  switch (status) {
    case 'completed':
      return { label: 'Concluída', class: 'status-completed', icon: '✓' };
    case 'in_progress':
      return { label: 'Em Andamento', class: 'status-progress', icon: '⏳' };
    case 'postponed':
      return { label: 'Adiada', class: 'status-postponed', icon: '📅' };
    case 'cancelled':
      return { label: 'Cancelada', class: 'status-cancelled', icon: '✕' };
    default:
      return { label: 'Pendente', class: 'status-todo', icon: '○' };
  }
}

export { formatTimeBR } from './date.js';

